import { ChangeEvent, forwardRef } from "react";

interface Props {
	label?: string;
	warningText?: string;
	value: string;
	name?: string;
	type?: string;
	placeholder?: string;
	className?: string;
	maxLength?: number;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	editable?: boolean;
	titleless?: boolean;
}

const CommonInput = forwardRef<HTMLInputElement, Props>(({ 
	label = "",
	warningText = undefined,
	value = "",
	name = "input",
	type = "text",
	placeholder = "input 값을 입력해주세요",
	className = "",
	maxLength = undefined,
	onChange = (e) => { console.log('changed!') },
	onKeyDown = (e) => { console.log('default Key pressed:', e.key) },
	editable = false,
	titleless = false,
}, ref) => {
  return (
    <div className="flex flex-col w-full gap-[4px]">
      <div className="w-full flex gap-[6px] items-end">
        {label && <p className={`font-semibold text-gray-700 ${titleless ? 'hidden' : ''}`}>{label}</p>}
        {warningText && <p className="text-red-lightest text-[8px] pb-[2px]">{warningText}</p>}
      </div>
      <div className="relative">
        <input
			value={value} name={name} ref={ref} type={type} placeholder={placeholder}
			className={`rounded-[10px] w-full min-h-[52px] h-[clamp(52px,11vw,60px)] px-[clamp(14px,3vw,18px)]
				text-[clamp(15px,3.4vw,20px)] leading-snug placeholder:text-gray-500 bg-gray-bg
				focus:border-blue-dark focus:outline-none
				${warningText !== undefined && 'border-[1px] border-red-lightest'} ${className}`}
			onChange={onChange}
			onKeyDown={onKeyDown}
			disabled={editable}
        />
        {maxLength && <p className="absolute text-[12px] text-gray-500 top-[50%] right-[12px] translate-y-[-50%]">
          {value.length} / {maxLength}
        </p>}
      </div>
    </div>
  );
});

export default CommonInput;